import { Grid } from "@mui/material";
import {
  minValue,
  NumberInput,
  ReferenceInput,
  required,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { DormitoryStudentTypeChoices } from "utils/choices";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";

const SaveForm = () => (
  <Grid
    container
    spacing={2}
  >
    <Grid
      item
      xs={12}
      md={4}
    >
      <NumberInput
        source="amount"
        label="Субсидия (EUR)"
        format={v => (v !== undefined && v !== null && v !== "" ? Number(v).toFixed(2) : "")}
        parse={v => (v === "" ? null : parseFloat(parseFloat(v).toFixed(4)))}
        validate={[required(), minValue(0.0001)]}
        onWheel={e => e.target.blur()}
        fullWidth
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <ReferenceInput
        source="receptionTypeId"
        reference={administrationRequests.getReceptionTypesSelect()}
      >
        <DormitoryAutocompleteInput
          label="Вид прием"
          optionText="name"
          validate={[required()]}
          fullWidth
        />
      </ReferenceInput>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <DormitoryAutocompleteInput
        source="studentType"
        label="Тип студент"
        choices={DormitoryStudentTypeChoices}
        validate={[required()]}
        fullWidth
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <CustomDateInput
        source="validFrom"
        label="Валидна от"
        validate={required()}
        required={true}
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <CustomDateInput
        source="validTo"
        label="Валидна до"
        validate={required()}
        required={true}
      />
    </Grid>
  </Grid>
);

export default SaveForm;
